module.exports = __webpack_public_path__ + "media/images/logotype-rouge-19a97edc6168f8258278886c5e0c8c57.svg";